// src/pages/AboutPage.js
import React from 'react';

const h1Style = {
  fontSize: '1.5rem',
  fontWeight: '600',
  borderBottom: '1px solid #d0d7de',
  paddingBottom: '0.75rem',
  marginBottom: '1.5rem',
  transition: 'font-size 0.2s ease-in-out', // 부드러운 전환 효과
};

const h2Style = {
  fontSize: '1.25rem',
  fontWeight: '600',
  marginTop: '2rem',
  marginBottom: '1rem',
  transition: 'font-size 0.2s ease-in-out', // 부드러운 전환 효과
  wordBreak: 'keep-all',
  textalign: 'left'
};

const AboutPage = () => {
  return (
    <div style={{ padding: '2rem' }} className="content-box">
      <h1 style={h1Style}> 꿀단지개미 - 개미를 위한 금융 데이터 시각화 플랫폼</h1>
      <p>
        <code>꿀단지개미</code>는 데이터 기반의 합리적인 투자 결정을 돕기 위한 금융 데이터 시각화 웹페이지입니다.<br/> 
        위 페이지는 개인이 소규모로 운영하는 프로젝트입니다. 지속적인 운영을 위해 많은 관심과 피드백 부탁드립니다.
      </p>
      
      <h2 style={h2Style}>꿀단지개미의 목표</h2>
      <p>
        개인 투자자들이 접근하기 어려웠던 금융 데이터를 보기 쉽게 가공하고, 다양한 분석 도구를 제공하여 자신만의 투자 전략을 수립할 수 있도록 지원하는 것을 목표로 합니다.
      </p>

      <h2 style={h2Style}>주의사항</h2>
      <p>
        본 플랫폼에서 제공하는 모든 정보는 투자의 참고 자료이며, 특정 자산의 매수 또는 매도를 추천하는 것이 아닙니다. 모든 투자의 최종 결정과 책임은 투자자 본인에게 있습니다.
      </p>
    </div>
  );
};

export default AboutPage;